import { Component, OnInit } from '@angular/core';
import { ActionUpdaterService } from '../../services/action-updater.service';

@Component({
  selector: 'gaweb-toast',
  template: `
    <div *ngFor="let alert of alerts" class="col-xs-12 col-md-4 col-xs-offset-9 col-md-offset-4 success-alert container-bleed">

        <alert [type]="alert.type" [dismissOnTimeout]="alert.timeout">

        <span *ngIf="alert.type ==='success'" class="glyphicon glyphicon-ok" aria-hidden="true"></span>

        {{ alert.msg }}

        <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>

        </alert>
    </div>
  `
 })
export class ToastComponent implements OnInit {
  alerts: Array<any> = [];

  constructor( private actionUpdaterService: ActionUpdaterService) { }

  ngOnInit() {
    this.actionUpdaterService.success$.subscribe(
      message => {
          this.alerts.push({
              type: 'success',
              timeout: '5000',
              msg: message
          });
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/toast/toast.component.ts